module.exports = __webpack_public_path__ + "img/airplane-4.6c88ccee.jpg";